module.exports = __webpack_public_path__ + "img/question.53b1bea9.svg";